export default __webpack_public_path__ + "static/media/Zeus.f258c284.png";